import { render, staticRenderFns } from "./InformationBlock.vue?vue&type=template&id=9bd3eb38&scoped=true"
import script from "./InformationBlock.ts?vue&type=script&lang=ts&external"
export * from "./InformationBlock.ts?vue&type=script&lang=ts&external"
import style0 from "./InformationBlock.scss?vue&type=style&index=0&id=9bd3eb38&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd3eb38",
  null
  
)

export default component.exports